import script from "./EstimateFee.vue?vue&type=script&setup=true&lang=js"
export * from "./EstimateFee.vue?vue&type=script&setup=true&lang=js"

import "./EstimateFee.vue?vue&type=style&index=0&id=6c87479e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c87479e"]])

export default __exports__